import { useEffect } from 'react';
import type { MapShellRenderState } from './MapShell';
import { type DealStageRow, useDealsStageFilter } from '../hooks/useDealsStageFilter';

export interface DealsStagePanelState {
  stages: DealStageRow[];
  toggleStage: (stage: string) => void;
  toggleAllStages: () => void;
}

interface DealsStageSyncProps {
  shell: MapShellRenderState;
  /** True once the deals layer is paintable (flag + map ready). */
  ready: boolean;
  onChange: (state: DealsStagePanelState) => void;
}

/** Bridges `useDealsStageFilter` up to the left sidebar; renders nothing itself. */
export function DealsStageSync({ shell, ready, onChange }: DealsStageSyncProps) {
  const { stages, toggleStage, toggleAllStages } = useDealsStageFilter(shell.map, ready);

  // biome-ignore lint/correctness/useExhaustiveDependencies: onChange identity is not the caller's concern
  useEffect(() => {
    onChange({ stages, toggleStage, toggleAllStages });
  }, [stages, toggleStage, toggleAllStages]);

  return null;
}
